import { ListItemText, MenuItem, TextField } from '@mui/material'
import React, { useEffect } from 'react'

function DropDownForListing({ name, value, onChange, list }) {

    const defaultList = [
        { label: "All", value: "All" },
        { label: "Active", value: "Active" },
        { label: "Cancelled", value: "Cancelled" },
        // { label: "Deleted", value: "Deleted" },

    ]
    list = list || defaultList

    return (
        <TextField
            select
            id=""
            name=""
            // disabled={params?.view == true ? true : false}
            variant="outlined"
            required={true}
            size="small"
            value={value}
            InputLabelProps={{
                shrink: true,
            }}
            fullWidth
            onChange={onChange}
            sx={{
                height: name == "ser" ? "40px" : "",
                justifyContent: "center",
                width: { sm: 100, md: 150 },
                marginLeft: { sm: "10px", md: 4 },
                fontSize: 18,
                boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.2)",
                // boxShadow:
                //     `-4px -4px 4px rgba(255, 255, 255, 0.25), 4px 4px 4px ${name == "ser" ? "" : "#cdcde7"}`,
                // background: "white",
                background: name !== "ser" ? "bodyGray.main" : "white",
                borderRadius: "6px",
                border: "none",
                outline: "none",
                ".MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    outline: "none",
                },
                ".MuiInputBase-input ": {
                    color: "primary.main",
                },
                ".MuiSvgIcon-fontSizeMedium ": {
                    color: "primary.main",
                    fontSize: "30px",
                },
                ".MuiSelect-select": {
                    height: 30,
                },
                boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
            }}
            inputProps={{ style: { color: "primary.main" } }}
        >
            {list?.map((elem) => {
                return <MenuItem value={elem.value} >
                    <ListItemText primary={elem.label} />
                </MenuItem>
            })
            }
        </TextField>
    )
}

export default DropDownForListing